import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setPaymenthsMethods } from '../../redux/paymenthsMethodsReducer'
import { errorMessage, openMessage, successfullyMessage } from '../Messages'
import { getPaymentsMethods } from '../paymenthsMethods/services/getPaymenths'

function useInitPaymenthsMethods({ data, fDate, eDate, date }) {

    const dispatch = useDispatch()
    const [lastFilterDates, setLastFilterDates] = useState({})

    const initPaymenthsMethods = useCallback(async () => {
        openMessage({ message: "Cargando..." })
        const { result, message, error_msg } = await getPaymentsMethods({ fDate, eDate, date })
        if (message.includes('Successfully')) {
            successfullyMessage({ message: "Datos Cargados" })
            dispatch(setPaymenthsMethods(result))
        } else if (!!error_msg) {
            errorMessage({ message: "Ocurrió un error" })
        }
    }, [dispatch, fDate, eDate, date])

    useEffect(() => {
        (async () => {
            if (data?.length > 0 && !!fDate && !!eDate) {
                if (fDate != lastFilterDates?.fDate || eDate != lastFilterDates?.eDate) {
                    initPaymenthsMethods()
                    setLastFilterDates({ fDate: fDate, eDate: eDate })
                }
            } else if (data?.length === 0 && !!fDate && !!eDate) {
                initPaymenthsMethods()
                setLastFilterDates({ fDate: fDate, eDate: eDate })
            }
        })()
    }, [initPaymenthsMethods, data, fDate, eDate, date])
}

export default useInitPaymenthsMethods